import { HUAPU } from './huapuBrand';
export function getGIDefaults() {
  return {
    productName: '', subtitle: '', gi: '', gl: '', tags: '', images: [],
    brand: '', barcode: '', netContent: '', shelfLife: '', ingredients: '', origin: '',
    manufacturer: '', address: '', hotline: '',
    reportTitle: 'GI 血糖生成指数检测报告', reportNumber: '', institution: HUAPU.name,
    method: HUAPU.method, testDate: '', reportUrl: '', reportPassed: true,
    companyName: '', companyAddress: '', creditCode: '', enterpriseVerified: true,
    batchNumber: '', productionDate: '', expiryDate: '', batchQuantity: '',
    websiteName: '', websiteEnglish: '', websiteUrl: '', websiteLogo: '', websiteQRCode: '',
    filingNumber: '', provider: '', nutritionNote: '', demo: false,
  };
}
